<template>
  <div
    id="exception_toast"
    class="toast toast-position"
    role="alert"
    aria-live="assertive"
    aria-atomic="true"
  >
    <div
      :class="`toast-header ${isPositive ? 'success-header' : 'alert-header'}`"
    >
      <strong class="mr-auto">{{ isPositive ? "Success" : "Error" }}</strong>
      <button
        type="button"
        class="ml-2 mb-1 close"
        data-bs-dismiss="toast"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="toast-body">
      {{ prospectCallbackErrorMsg }}
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import { Toast } from "bootstrap";

@Component({})
export default class ExceptionHandler extends Vue {
  public toastDelay = 3000;

  @Prop()
  public prospectCallbackErrorMsg!: any;

  @Prop()
  public isPositive = false;

  mounted() {
    const exceptionToast = document.getElementById("exception_toast");
    if (exceptionToast) {
      const toastInstance = new Toast(exceptionToast, {
        delay: this.toastDelay,
      });
      toastInstance.show();
      exceptionToast.addEventListener("hidden.bs.toast", () => {
        this.$emit("resetShowProspectCallbackError", {
          isSuccess: this.isPositive,
        });
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.toast-header {
  justify-content: space-between;
}
.toast-position {
  padding: 0;
  top: 5px;
  right: 5px;
  z-index: 9999;
  position: fixed;
  width: fit-content;
  height: auto;
  margin: 5px;
  border: 1px solid transparent;

  .alert-header {
    color: #721c24;
    background-color: #f8d7da;
    border-color: #f5c6cb;
  }

  .success-header {
    color: green;
    background-color: lightgreen;
    border-color: lightgreen;
  }

  .toast-body {
    word-break: break-word;
  }
}
</style>
